// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1GmyU","selects":"Documents_selects__3Lkog"};